import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ChatMessagesAttachmentFileAPI = /** @class */ (function () {
    function ChatMessagesAttachmentFileAPI(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ChatMessagesAttachmentFileAPI.initialize = function (basePath, fetchApi) {
        if (!ChatMessagesAttachmentFileAPI.instance) {
            ChatMessagesAttachmentFileAPI.instance = new ChatMessagesAttachmentFileAPI(basePath, fetchApi);
        }
        return ChatMessagesAttachmentFileAPI.instance;
    };
    ChatMessagesAttachmentFileAPI.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ChatMessagesAttachmentFileApi(new Configuration(config));
    };
    return ChatMessagesAttachmentFileAPI;
}());
export { ChatMessagesAttachmentFileAPI };
